import { Svg, G, Path, Circle } from "react-native-svg";
import { increase_brightness, colorLuminance } from "../context/helper";
import { View } from "react-native";

const RSSIImage = ({ size, color, signal, rssi, style, goodColor = "#000000", badColor = "#660000", weakColor = "#666600", doincrease = true}) => {

  /*   const Color1_1 = "#0093F7";
  const Color1_2 = "#00A6F9";

  const Color2_1 = "#0093F7";
  const Color2_2 = "#00A6F9";

  const Color3_1 = "#ACD9E5";
  const Color3_2 = "#BFDFE8";

  const Color4_1 = "#ACD9E5";
  const Color4_2 = "#BFDFE8";

  0 - 14 - 77 - 85
 
  const Color1_1 = "#000000";
  const Color1_2 = "#242424";

  const Color2_1 = "#000000";
  const Color2_2 = "#242424";

  const Color3_1 = "#c5c5c5";
  const Color3_2 = "#dadada";

  const Color4_1 = "#c5c5c5";
  const Color4_2 = "#dadada";
*/

  if (rssi) {
    // no signal 0 Points (gray)
    color = goodColor;
    signal = 0;

    if (rssi > -100 && rssi != 0) {
      if (rssi >= -30) {
        // full signal 4 Points (black)
        color = goodColor;
        signal = 4;
      } else if (rssi >= -50) {
        // to -69
        // good signal 3 Points (black)
        color = goodColor;
        signal = 3;
      } else if (rssi >= -70) {
        // to -79
        // medium signal 2 Points (black)
        color = goodColor;
        signal = 2;
      } else if (rssi >= -80) {
        // to -89
        // low signal 2 Points (yellow)
        color = weakColor;
        signal = 2;
      }
      else if (rssi >= -90) {
        // to -99
        // very low signal 1 Point (red)
        color = badColor;
        signal = 1;
      } 
    }
  } else {
    if (!color) color = goodColor;
    if (!signal) signal = 0;
  }

  const fact = doincrease?1:-1;

  const ActiveColor = { 1: color, 2: doincrease? increase_brightness(color, 20):colorLuminance(color,-0.2) };
  const InactiveColor = {
    1: doincrease?increase_brightness(color, 75):colorLuminance(goodColor,-0.70),
    2: doincrease?increase_brightness(color, 85):colorLuminance(goodColor,-0.80),
  };

  const color1_1 = signal > 0 ? ActiveColor[1] : InactiveColor[1];
  const color1_2 = signal > 0 ? ActiveColor[2] : InactiveColor[2];

  const color2_1 = signal > 1 ? ActiveColor[1] : InactiveColor[1];
  const color2_2 = signal > 1 ? ActiveColor[2] : InactiveColor[2];

  const color3_1 = signal > 2 ? ActiveColor[1] : InactiveColor[1];
  const color3_2 = signal > 2 ? ActiveColor[2] : InactiveColor[2];

  const color4_1 = signal > 3 ? ActiveColor[1] : InactiveColor[1];
  const color4_2 = signal > 3 ? ActiveColor[2] : InactiveColor[2];

  return (
    <View style={style}>
      <Svg height={size} width={size} id="Layer_1" viewBox="0 0 504.8 504.8">
        <G>
          <Path
            fill={color4_2}
            d="M480,203.5c-6.4,0-12-2.4-16.8-7.2c-116.8-116-305.6-116-422.4,0c-9.6,9.6-24.8,9.6-33.6,0
          c-9.6-9.6-9.6-24.8,0-33.6c135.2-135.2,355.2-135.2,490.4,0c9.6,9.6,9.6,24.8,0,33.6C492.8,201.1,486.4,203.5,480,203.5z"
          />
          <Path
            fill={color3_2}
            d="M396,288.3c-6.4,0-12-2.4-16.8-7.2c-70.4-70.4-184-70.4-254.4,0c-9.6,9.6-24.8,9.6-33.6,0
          c-9.6-9.6-9.6-24.8,0-33.6c88.8-88.8,232.8-88.8,321.6,0c9.6,9.6,9.6,24.8,0,33.6C408,285.9,402.4,288.3,396,288.3z"
          />
        </G>
        <G>
          <Path
            fill={color2_2}
            d="M309.6,369.1c-6.4,0-12-2.4-16.8-7.2c-22.4-22.4-59.2-22.4-81.6,0c-9.6,9.6-24.8,9.6-33.6,0
		c-9.6-9.6-9.6-24.8,0-33.6c40.8-40.8,108-40.8,148.8,0c9.6,9.6,9.6,24.8,0,33.6C321.6,366.7,316,369.1,309.6,369.1z"
          />
          <Circle fill={color1_2} cx="252" cy="419.5" r="24" />
        </G>
        <G>
          <Path
            fill={color4_1}
            d="M7.2,189.1c-0.8,0.8-2.4,2.4-3.2,4c0.8,1.6,1.6,2.4,3.2,4c9.6,9.6,24.8,9.6,33.6,0
          c116.8-116.8,305.6-116.8,422.4,0c4.8,4.8,11.2,7.2,16.8,7.2s12-2.4,16.8-7.2c0.8-0.8,2.4-2.4,3.2-4c-0.8-1.6-1.6-2.4-3.2-4
          C361.6,53.9,142.4,53.9,7.2,189.1z"
          />
          <Path
            fill={color3_1}
            d="M91.2,273.9c-0.8,0.8-2.4,2.4-3.2,4c0.8,1.6,1.6,2.4,3.2,4c9.6,9.6,24.8,9.6,33.6,0
          c70.4-70.4,184-70.4,254.4,0c4.8,4.8,11.2,7.2,16.8,7.2s12-2.4,16.8-7.2c0.8-0.8,2.4-2.4,3.2-4c-0.8-1.6-1.6-2.4-3.2-4
          C324,185.1,180,185.1,91.2,273.9z"
          />
        </G>
        <G>
          <Path
            fill={color2_1}
            d="M177.6,354.7c-0.8,0.8-2.4,2.4-3.2,4c0.8,1.6,1.6,2.4,3.2,4c9.6,9.6,24.8,9.6,33.6,0
          c22.4-22.4,59.2-22.4,81.6,0c4.8,4.8,11.2,7.2,16.8,7.2s12-2.4,16.8-7.2c0.8-0.8,2.4-2.4,3.2-4c-0.8-1.6-1.6-2.4-3.2-4
          C285.6,313.1,218.4,313.1,177.6,354.7z"
          />
          <Path
            fill={color1_1}
            d="M252,421.9c-8,0-16,4-20,10.4c4,6.4,12,10.4,20,10.4s16-4,20-10.4C268,426.7,260,421.9,252,421.9z"
          />
        </G>
      </Svg>
    </View>
  );
};

export default RSSIImage;
